import Loading from 'quasar/src/plugins/Loading.js';import QSpinnerBars from 'quasar/src/components/spinner/QSpinnerBars.js';;
import { router } from '../main';

function clearStore(state) {
    (state.userId = null),
        (state.userName = null),
        (state.userRole = null),
        (state.password = null),
        (state.loginError = ''),
        (state.userAuthenticated = false),
        (state.isLoginLoader = false),
        (state.menus = []),
        (state.items = []),
        (state.showDisplay = false);
    state.logoutModal = false;
    state.isAuthRefreshed = false;
    state.authInitialized = false;
}

export default {
    // common mutations
    setBaseUrl(state, data) {
        console.log('data: ', data);
        state.url = data;
    },
    openLogoutDialog(state) {
        state.logoutModal = true;
    },
    loginErrorHandler(state, message) {
        state.loginError = message;
    },
    loginLoaderHandler(state, bool) {
        if (bool) {
            state.isLoginLoader = true;
        } else {
            state.isLoginLoader = false;
        }
    },

    showDispaly(state, data) {
        state.showDisplay = data;
    },

    // user mutations
    loginHandler(state, data) {
        try {
            clearStore(state);
            state.userAuthenticated = true;
            state.userId = data.userId;
            state.userName = data.userName;
            state.userRole = data.roleId;
            // state.showDisplay = true;
            state.menus = data.menus;
            const PATH = router?.history._startLocation;
            console.log('PATH: ', PATH);
            if (data.isloggedIn && state.userAuthenticated) {
                let redirectLocation = PATH !== '/login' && PATH !== '' ? PATH : '/';
                router
                    .push(redirectLocation)
                    .catch(() => { })
                    .then(() => {
                        Loading.show({
                            spinner: QSpinnerBars,
                            spinnerColor: 'primary',
                            backgroundColor: 'white',
                            spinnerSize: 100,
                            message: 'Loading...',
                            messageColor: 'white',
                        });
                    })
                    .catch((err) => console.log(err.name));
            } else {
                router
                    .push('/login')
                    .catch(() => { })
                    .then(() => {
                        Loading.show({
                            spinner: QSpinnerBars,
                            spinnerColor: 'primary',
                            backgroundColor: 'white',
                            spinnerSize: 100,
                            message: 'Loading...',
                            messageColor: 'white',
                        });
                    })
                    .catch((err) => console.log(err.name));
            }
            setTimeout(() => {
                Loading.hide();
                state.authInitialized = false;
            }, 2000);
        } catch (error) {
            console.error(error);
        }
    },
    logOutHandler(state) {
        sessionStorage.removeItem('token');
        state.authInitialized = false;
        clearStore(state);
        // localStorage.set('token', false);
        state.userAuthenticated = false;
        router.push('/login').catch(() => { });
    },

    setItems(state, data) {
        state.items = data;
        state.isItemState = true;
    },

    setUserMenu(state, menus) {
        state.menus = menus;
        state.userId = menus[0]?.userId
        setTimeout(() => {
            const currentRoute = location.pathname || '/';
            const currentRoutetMenuId = router.history.current.query.id || 1;
            const currentMenu =
                menus.find(m => m?.menuUrl === currentRoute) ||
                menus.find(m => m?.id === currentRoutetMenuId);

            console.log('currentMenu:', currentMenu);

            state.menu = currentMenu;
            state.showDisplay = true;
        }, 100);
    },

    setMenu(state, menu) {
        state.menu = menu;
    },

    logoutUser(state) {
        sessionStorage.setItem('token', null);
        state.userAuthenticated = false;
    },
    setAuthInitialized(state, value) {
        state.authInitialized = value;
    },
    setAuthState(state, value) {
        state.isAuthRefreshed = value;
    },
    setServerDate(state, date) {
        state.serverDate = date;
    },
};